"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.from");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _lottery = require("@/api/activity/lottery");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _PhoneUserSelect = _interopRequireDefault(require("@/components/PhoneUserSelect"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LotteryRecordPane',
  components: {
    PhoneUserSelect: _PhoneUserSelect.default
  },
  props: {
    lotteryId: {
      type: Number,
      default: null
    },
    lotteryTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchForm: {
        userId: null,
        prizeName: '',
        isSend: null,
        dateRange: []
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      exportLoading: false,
      // 会员等级列表
      vipGradeList: [],
      // 奖品名称列表
      prizeNameList: [],
      // 活动详情中的pack数据
      packData: [],
      // 图片路径
      imgPath: process.env.VUE_APP_IMAGE_PATH,
      // 发放按钮loading状态
      sendLoadingMap: {}
    };
  },
  mounted: function mounted() {
    if (this.lotteryId) {
      this.loadVipGradeList();
      this.loadLotteryDetail();
      this.fetchData();
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    // 加载会员等级列表
    loadVipGradeList: function () {
      var _loadVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipGradeList = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name
                  };
                });
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取会员等级列表失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadVipGradeList() {
        return _loadVipGradeList.apply(this, arguments);
      }
      return loadVipGradeList;
    }(),
    // 加载活动详情，获取奖品列表
    loadLotteryDetail: function () {
      var _loadLotteryDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, data, pack, nameSet, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _lottery.getLotteryDetail)(this.lotteryId);
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                data = response.data; // 解析pack数据
                if (data.pack) {
                  pack = [];
                  if (typeof data.pack === 'string') {
                    try {
                      pack = JSON.parse(data.pack);
                    } catch (e) {
                      console.error('解析pack数据失败:', e);
                    }
                  } else if (Array.isArray(data.pack)) {
                    pack = data.pack;
                  }

                  // 提取奖品名称列表（去重）
                  nameSet = new Set();
                  pack.forEach(function (item) {
                    if (item.name) {
                      nameSet.add(item.name);
                    }
                  });
                  this.prizeNameList = Array.from(nameSet).map(function (name) {
                    return {
                      name: name
                    };
                  });
                  this.packData = pack;
                }
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取活动详情失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadLotteryDetail() {
        return _loadLotteryDetail.apply(this, arguments);
      }
      return loadLotteryDetail;
    }(),
    // 获取会员等级名称
    getUserRankName: function getUserRankName(userRank) {
      var grade = this.vipGradeList.find(function (g) {
        return g.id === userRank;
      });
      return grade ? grade.name : '-';
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.tableLoading = true;
              _context3.prev = 1;
              params = {
                page: this.currentPage,
                limit: this.pageSize,
                lotteryId: this.lotteryId,
                userId: this.searchForm.userId,
                prizeName: this.searchForm.prizeName,
                isSend: this.searchForm.isSend
              };
              if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
              }
              _context3.next = 2;
              return (0, _lottery.getLotteryRecordList)(params);
            case 2:
              response = _context3.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取数据失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              this.$message.error('获取数据失败：' + _t3.message);
            case 4:
              _context3.prev = 4;
              this.tableLoading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handlePhoneUserSelect: function handlePhoneUserSelect() {
      // 选中用户即触发查询，提升体验
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        userId: null,
        prizeName: '',
        isSend: null,
        dateRange: []
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.exportLoading = true;
              _context4.prev = 1;
              this.$message.info('正在导出抽奖记录...');
              params = {
                lotteryId: this.lotteryId,
                userId: this.searchForm.userId,
                prizeName: this.searchForm.prizeName,
                isSend: this.searchForm.isSend
              };
              if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
              }
              _context4.next = 2;
              return (0, _lottery.exportLotteryRecord)(params);
            case 2:
              response = _context4.sent;
              if (response && response.code === 200) {
                this.$message.success(response.message || '数据导出中，请稍后查看下载文件');
              } else {
                this.$message.error(response.message || '导出失败');
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              console.error('导出失败:', _t4);
              this.$message.error('导出失败：' + (_t4.message || '网络异常'));
            case 4:
              _context4.prev = 4;
              this.exportLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    handleSendPrize: function () {
      var _handleSendPrize = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$confirm('确认发放该奖品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var response, _t5;
                return regeneratorRuntime.wrap(function (_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      // 设置loading状态
                      _this.$set(_this.sendLoadingMap, row.id, true);
                      _context5.prev = 1;
                      _context5.next = 2;
                      return (0, _lottery.sendLotteryPrize)(row.id);
                    case 2:
                      response = _context5.sent;
                      if (response.code === 200 && response.data) {
                        if (response.data.success) {
                          _this.$message.success(response.data.message || '发放成功');
                        } else {
                          _this.$message.error(response.data.message || '发放失败');
                        }
                        _this.fetchData();
                      } else {
                        _this.$message.error(response.message || '发放失败');
                      }
                      _context5.next = 4;
                      break;
                    case 3:
                      _context5.prev = 3;
                      _t5 = _context5["catch"](1);
                      _this.$message.error('发放失败：' + _t5.message);
                    case 4:
                      _context5.prev = 4;
                      // 清除loading状态
                      _this.$set(_this.sendLoadingMap, row.id, false);
                      return _context5.finish(4);
                    case 5:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5, null, [[1, 3, 4, 5]]);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleSendPrize(_x) {
        return _handleSendPrize.apply(this, arguments);
      }
      return handleSendPrize;
    }(),
    formatTime: function formatTime(time) {
      if (!time) return '-';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    getPrizeTypeName: function getPrizeTypeName(award) {
      if (!award) return '谢谢参与';
      try {
        var awardObj = typeof award === 'string' ? JSON.parse(award) : award;
        var awardType = awardObj.award_type || awardObj.awardType;
        var typeMap = {
          0: '谢谢参与',
          1: '优惠券',
          2: '积分',
          3: '周边',
          4: '再来一次'
        };
        return typeMap[awardType] || '谢谢参与';
      } catch (e) {
        return '其他';
      }
    },
    getPrizeTypeTag: function getPrizeTypeTag(award) {
      if (!award) return 'info';
      try {
        var awardObj = typeof award === 'string' ? JSON.parse(award) : award;
        var awardType = awardObj.award_type || awardObj.awardType;
        var tagMap = {
          0: 'info',
          1: 'success',
          2: 'warning',
          3: 'primary',
          4: 'info'
        };
        return tagMap[awardType] || '';
      } catch (e) {
        return '';
      }
    },
    getSourceTypeName: function getSourceTypeName(stype) {
      var typeMap = {
        1: '订单赠送',
        2: '每日赠送',
        3: '抽奖赠送',
        4: '邀请赠送',
        5: '后台赠送',
        6: '企微赠送',
        10: '积分抽奖'
      };
      return typeMap[stype] || '-';
    },
    getSourceTypeTag: function getSourceTypeTag(stype) {
      var tagMap = {
        1: 'success',
        2: 'primary',
        3: 'warning',
        4: 'info',
        5: 'success',
        6: 'primary',
        10: 'warning'
      };
      return tagMap[stype] || '';
    },
    // 获取来源信息
    getSourceInfo: function getSourceInfo(row) {
      if (!row.sid) return '-';
      if (row.stype === 1) {
        return "\u8BA2\u5355\u53F7:".concat(row.sid);
      } else if (row.stype === 4) {
        return "\u53D7\u9080\u7528\u6237(\u7528\u6237id):".concat(row.sid);
      }
      return row.sid || '-';
    },
    // 处理头像URL，确保正确的前缀
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      // 如果已经是http开头，直接返回
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) {
        return userpic;
      }
      // 否则添加前缀
      return this.imgPath + userpic;
    },
    // 获取奖品图片URL
    getPrizeImageUrl: function getPrizeImageUrl(award) {
      if (!award) return '';
      try {
        var awardObj = typeof award === 'string' ? JSON.parse(award) : award;
        var imgUrl = awardObj.img_url || awardObj.imgUrl || '';
        if (!imgUrl) return '';
        // 如果已经是http开头，直接返回
        if (imgUrl.startsWith('http://') || imgUrl.startsWith('https://')) {
          return imgUrl;
        }
        // 否则添加前缀
        return this.imgPath + imgUrl;
      } catch (e) {
        return '';
      }
    },
    // 获取奖品名称
    getPrizeName: function getPrizeName(award) {
      if (!award) return '谢谢参与';
      try {
        var awardObj = typeof award === 'string' ? JSON.parse(award) : award;
        // 优先使用 awardName，其次使用 name
        return awardObj.award_name || awardObj.awardName || awardObj.name || '未知奖品';
      } catch (e) {
        return '未知奖品';
      }
    },
    // 获取会员等级标签类型
    getUserRankTagType: function getUserRankTagType(userRank) {
      var tagMap = {
        1: 'info',
        2: '',
        3: 'success',
        4: 'warning',
        5: 'danger'
      };
      return tagMap[userRank] || '';
    },
    // 获取发放状态标签类型
    getSendStatusTagType: function getSendStatusTagType(sendStatus) {
      if (sendStatus === 1) return 'success';
      if (sendStatus === 2) return 'danger';
      return 'warning';
    },
    // 获取发放状态文本
    getSendStatusText: function getSendStatusText(sendStatus) {
      if (sendStatus === 1) return '已发放';
      if (sendStatus === 2) return '发放失败';
      return '待发放';
    },
    // 判断是否中奖
    getIsWin: function getIsWin(award) {
      if (!award) return false;
      try {
        var awardObj = typeof award === 'string' ? JSON.parse(award) : award;
        var awardType = awardObj.award_type || awardObj.awardType;
        // awardType不为0即为中奖
        return awardType !== 0 && awardType !== undefined && awardType !== null;
      } catch (e) {
        return false;
      }
    }
  }
};